import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';

export default class EvaluatorLeadAdminItem {
  constructor(item) {
    if (item === undefined) {
      this.EvaluatorLeadId = null;
      this.LeadCreated = null;
      this.Name = '';
      this.Email = '';
      this.Source = '';
      this.Form = '';
      this.Channel = '';
      this.Stage = '';
      this.Owner = '';
      this.Labels = '';
      this.Phone = '';
      this.SecondaryPhone = '';
      this.WhatsAppNumber = '';
      this.TpEvaluatorId = null;
      this.EvaluatorId = null;
      this.Country = '';
      this.City = '';
      this.ShopCount = 0;
      this.RegisteredOn = null;
      this.CreatedOnUtc = null;
      this.ReferredBy = null;
      this.ReferredByName = '';
    } else {
      this.EvaluatorLeadId = item.evaluatorLeadId;
      this.LeadCreated = item.leadCreated;
      this.Name = item.name ?? '';
      this.Email = item.email ?? '';
      this.Source = item.source ?? '';
      this.Form = item.form ?? '';
      this.Channel = item.channel ?? '';
      this.Stage = item.stage ?? '';
      this.Owner = item.owner ?? '';
      this.Labels = item.labels ?? '';
      this.Phone = item.phone ?? '';
      this.SecondaryPhone = item.secondaryPhone ?? '';
      this.WhatsAppNumber = item.whatsAppNumber ?? '';
      this.TpEvaluatorId = item.tpEvaluatorId;
      this.EvaluatorId = item.evaluatorId;
      this.Country = item.country ?? '';
      this.City = item.city ?? '';
      this.ShopCount = item.shopCount ?? 0;
      this.RegisteredOn = item.registeredOn;
      this.CreatedOnUtc = item.createdOnUtc;
      this.ReferredBy = item.referredBy ?? null;
      this.ReferredByName = item.referredByName ?? '';
    }
  }

  static DateFields = ['LeadCreated', 'RegisteredOn', 'CreatedOnUtc'];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Lead Subscribed', orderById: 'LeadCreated', data: 'LeadCreated', minWidth: 25 },
      { label: 'Name', orderById: 'Name', data: 'Name', minWidth: 30 },
      { label: 'Email', orderById: 'Email', data: 'Email', minWidth: 40 },
      { label: 'Phone', orderById: 'Phone', data: 'Phone', minWidth: 25 },
      { label: 'Source', orderById: 'Source', data: 'Source', minWidth: 20 },
      { label: 'Form', orderById: 'Form', data: 'Form', minWidth: 25 },
      { label: 'Country', orderById: 'Country', data: 'Country', minWidth: 20 },
      { label: 'City', orderById: 'City', data: 'City', minWidth: 20 },
      { label: 'Evaluator ID', orderById: 'EvaluatorId', data: 'EvaluatorId', minWidth: 15 },
      { label: 'TP Evaluator ID', orderById: 'TpEvaluatorId', data: 'TpEvaluatorId', minWidth: 15 },
      { label: 'Registered On', orderById: 'RegisteredOn', data: 'RegisteredOn', minWidth: 25 },
      { label: 'Total Shop Count', orderById: 'ShopCount', data: 'ShopCount', minWidth: 15 },
      { label: 'Referred By', orderById: 'ReferredByName', data: 'ReferredByName', minWidth: 25 },
      { label: 'Bravo Created On', orderById: 'CreatedOnUtc', data: 'CreatedOnUtc', minWidth: 25 },
      {
        label: ' ',
        orderById: '',
        data: EvaluatorLeadAdminItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static getActionsContent(item) {
    const options = [];

    // Only manually created leads (Source = BARE Referral) can be edited; imported leads cannot.
    if (item.Source === 'BARE Referral') {
      options.push({
        text: 'Edit',
        iconName: 'fa-solid fa-pen',
        onClick: () => EvaluatorLeadAdminItem.editFunction(item),
      });
    }

    options.push({
      text: 'Comments',
      iconName: 'fa-solid fa-comments',
      onClick: () => EvaluatorLeadAdminItem.commentsFunction(item),
    });

    options.push({
      text: 'Anonymize',
      iconName: 'fa-solid fa-user-slash',
      roleKey: 'anonymize_evaluator_lead',
      onClick: () => EvaluatorLeadAdminItem.anonymizeFunction(item.EvaluatorLeadId),
    });

    return <DataTableActionMenu options={options} />;
  }

  static anonymizeFunction(id) {
    alert('Empty function!');
  }

  static commentsFunction(item) {
    alert('Empty function!');
  }

  static editFunction(item) {
    alert('Empty function!');
  }
}
